export const SOLICITUD = 1;
export const APROBADA = 2;
export const AGENDADA = 3;
export const EFECTIVA = 4;
export const RECONVERTIDA = 5;
export const CONTINUIDAD = 6;
export const REPROGRAMADA = 7;
export const SUSPENDIDA = 8;
export const CANCELADA = 9;
export const RECHAZADA = 10;
export const ANULADA = 11;

export default [
    {
        id: SOLICITUD,
        descripcion: 'SOLICITUD'
    },
    {
        id: APROBADA,
        descripcion: 'APROBADA'
    },
    {
        id: AGENDADA,
        descripcion: 'AGENDADA'
    },
    {
        id: EFECTIVA,
        descripcion: 'EFECTIVA'
    },
    {
        id: RECONVERTIDA,
        descripcion: 'RECONVERTIDA'
    },
    {
        id: CONTINUIDAD,
        descripcion: 'CONTINUIDAD'
    },
    {
        id: REPROGRAMADA,
        descripcion: 'REPROGRAMADA'
    },
    {
        id: SUSPENDIDA,
        descripcion: 'SUSPENDIDA'
    },
    {
        id: CANCELADA,
        descripcion: 'CANCELADA'
    },
    {
        id: RECHAZADA,
        descripcion: 'RECHAZADA'
    },
    {
        id: ANULADA,
        descripcion: 'ANULADA'
    }
]